import React from 'react';
import {
  FDBodyText, FDIcon, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

// We have not pulled error text colors into the DS yet because we haven't fully defined the rules for when/if
// all of the typography variants should be allowed to be the error red color. However we have a pretty
// good use case for a red text error alert with an icon so we are using this custom css to achieve that in
// this one-off case.
const useStyles = buildUseStyles('TextErrorAlert', (theme) => ({
  errorText: {
    '& .FD-MuiTypography-body-md': {
      color: `${theme.palette.error.main} !important`,
    },
  },
}));

export const TextErrorAlert = ({ value }) => {
  const classes = useStyles();

  if (!value) {
    return null;
  }
  return (
    <FDStack spacing={1} alignItems={'center'}>
      <FDIcon icon={'error'} color={'error'} />
      <div className={classes.errorText}>
        <FDBodyText value={value} />
      </div>
    </FDStack>
  );
};


TextErrorAlert.propTypes = {
  value: PropTypes.string.isRequired,
};
